import { VerifyMatchTarget } from './verify-match-types';
import { VerifyMatchMentionContent } from './VerifyMatchMentionContent';
import { VerifyMatchSpotTranscription } from './VerifyMatchSpotTranscription';

export interface VerifyMatchTranscriptionProps {
  target: VerifyMatchTarget;
  stationId: string;
  timezone: string;
  open: boolean;
}

/**
 * Shows creative/script text for spot matches or programmed mention content for live mentions.
 */
export function VerifyMatchTranscription({
  target,
  stationId,
  timezone,
  open,
}: VerifyMatchTranscriptionProps) {
  if (target.kind === 'mention') {
    return (
      <VerifyMatchMentionContent
        mention={target.mention}
        stationId={stationId}
        timezone={timezone}
        open={open}
      />
    );
  }

  return <VerifyMatchSpotTranscription match={target.match} stationId={stationId} open={open} />;
}
